import React from 'react'

const FilterIcon = (props) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M15 1H1V6.02564L6.6 8.17949V15L10.8 13.5641V8.17949L15 6.02564' stroke='#33354D' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}

export default FilterIcon
